import MockAdapter from 'axios-mock-adapter/types';

const mockCommon = (_mock: MockAdapter) => {
	return 'ok';
};

export default mockCommon;
